import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { IAppState } from "../store/states/app";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BidUpdateService {
  private result = new BehaviorSubject({});
  private bidStartedResult = new BehaviorSubject({});

  constructor() {}

  bidStarted(data) {
    this.bidStartedResult.next(data.data);
  }

  updateData(data) {
    this.result.next(data.data);
  }

  get updatedData() {
    return this.result as Observable<any>;
  }

  get bidStartedData() {
    return this.bidStartedResult as Observable<any>;
  }
}
